module.exports = __webpack_public_path__ + "static/media/navBar-workload.a34fe022.svg";